module.exports = __webpack_public_path__ + "static/media/ai-ad-talarico.a6059204.mp4";